import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';
import { GuidanceNote } from '@app/shared/models/guidanceNote';
import { GuidanceNotesService } from '@shared/services/guidanceNotes.service';
@Component({
  selector: 'db-custom-field-radio-dialog',
  templateUrl: './guidance-notes-editor-dialog.component.html',
  styleUrls: ['./guidance-notes-editor-dialog.component.scss']
})
export class GuidanceNotesEditorDialogComponent implements OnInit {
  editor: any;
  tinyMceConfig: any;

  public OutputForm: FormControl;
  public guidanceNote: GuidanceNote;

  constructor(
    private GuidanceNotesService: GuidanceNotesService,
    private editorDialogRef: MatDialogRef<GuidanceNotesEditorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.editorDialogRef.updateSize('900px');
    this.guidanceNote = this.data['guidanceNote'];
  }

  configureTinyMce() {
    return {
      base_url: '/tinymce',
      branding: false,
      height: 200,
      skin: 'oxide',
      menubar: false,
      plugins: [
        'advlist lists link image directionality',
        'searchreplace visualblocks visualchars media table contextmenu paste textcolor colorpicker pagebreak code'
      ],
      toolbar: 'copy undo redo formatselect | bold italic strikethrough forecolor backcolor | fontselect fontsizeselect |link | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent  | removeformat hr pagebreak code',
      image_advtab: true,
      imagetools_toolbar: 'rotateleft rotateright | flipv fliph | editimage imageoptions',
      paste_data_images: !0,
      importcss_append: !0,
      setup: (editor) => {
        this.editor = editor;
      },
      images_upload_handler: function (e: any, t: any, a: any) {
        t('data:' + e.blob().type + ';base64,' + e.base64());
      }
    };
  }


  closeDialog() {
    this.guidanceNote.text = this.editor.getContent();
    this.GuidanceNotesService.addGuidanceNote(this.guidanceNote).subscribe();
    this.editorDialogRef.close();
  }

}
